<template>

    <div>
        <div class="flex flex-col md:flex-row">
            <div class="flex-1 text-center md:text-right md:pr-4">
                <img :src="invoiceImagePath" alt="Invoice"/>
            </div>
            <div class="flex-1 text-center md:text-left md:pl-4 flex flex-col justify-center">
                <div>
                    <p class="mb-1"><span class="sau-font-bold">Invoice: </span> {{ orderInvoice.id }}</p>
                    <a :href="invoiceUrl" target="_blank" class="btn btn-outline-success hover:border-green-600 hover:text-green-600 px-4 py-2">View Invoice</a>
                </div>
            </div>
        </div>
        <p v-if="creditApplied" class="text-green text-center my-4">
            A credit of {{ orderInvoice.credit | currency }} has been applied to your invoice.
        </p>

        <div class="mt-12" v-if="paymentMethod === 'bpay'">
            <h3>BPAY Details</h3>
            <p>Use the biller code and reference number to make a BPAY payment through your bank or financial institution.</p>
            <div class="flex flex-col md:flex-row">
                <div class="flex-1 md:pr-4">
                    <bpay />
                </div>
                <div class="flex-1 md:pl-4">
                    <p class="mb-0">Amount Owing</p>
                    <p class="text-2xl text-green">{{ orderInvoice.total | currency }}</p>
                </div>
            </div>
        </div>

        <div class="mt-12" v-if="paymentMethod === 'paypal'">
            <h3>Complete Your PayPal Payment</h3>
            <p>To finalise your purchase via PayPal, simply view your invoice and select the Pay Now button.</p>
            <div class="flex flex-col md:flex-row">
                <div class="flex-1 md:pr-4">
                    <a :href="invoiceUrl" target="_blank" class="btn btn-success px-4 py-2 mt-3">Complete Your Payment</a>
                </div>
                <div class="flex-1 md:pl-4">
                    <p class="mb-0">Amount Owing</p>
                    <p class="text-2xl text-green">{{ orderInvoice.total | currency }}</p>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import BpayVertical from '@js/components/utilities/BpayVertical';

export default {
    props: {
        orderInvoice: Object,
        paymentMethod: String,
    },

    components: {
        bpay: BpayVertical,
    },

    computed: {
        invoiceUrl() {
            return `/billing/invoices/${this.orderInvoice.id}`;
        },
        invoiceImagePath() {
            switch(this.orderInvoice.status.toLowerCase()) {
                case 'paid':
                    return '/img/illustrations/invoice-paid.gif';
                case 'unpaid':
                    return '/img/illustrations/invoice-unpaid.gif';
                default:
                    return '/img/illustrations/invoice-blank.gif';
            }
        },
        creditApplied() {
            return !! parseFloat(this.orderInvoice.credit);
        },
    }
}
</script>
